<template>
  <div>
      <span class="mr-7 title" style="width:140px;display:inline-block">选择的单位：</span>
      <el-cascader
        v-loading="loading"
        style="width:300px;"
        :options="options"
        :props="props"
        clearable
        :filterable="filterable"
        v-model="datas"
        :show-all-levels="isShowAllLevels"
        @change="onDataChanged"
      ></el-cascader>
  </div>
</template>

<script>
import {
  cascaderOptionsOwnApi,
} from "@/api/module/classunit/classunit";

export default {
  name: "UnitCascader",
  // props:{
  //   multiple: {
  //     type : Boolean,
  //     default: true
  //   }
  // },
  data() {
    return {
      isShowAllLevels: false,
      datas: [],
      filterable : true,
      loading : false,
      options: [     
        
      ],
      props: {
        multiple : true,
        checkStrictly : true
      }
    }
  },
  methods:{
    init(suc) {
      this.loading = true;
      cascaderOptionsOwnApi()
        .then((res) => {
            this.options = res;
            if (suc) {
              suc();
            }
          })
          .finally(() => {
            this.loading = false;
          });
     },

    // 初始化数据方法
    initData(datas) {
      console.log("init data",datas)
        this.init(() => {
          console.log("init data in callback")
          this.datas = datas;
          console.log("init data in callback finnal",this.options,this.datas)
        });
    },

    initCascaderData(datas) {
      console.log("init data",datas)
        this.init(() => {
          console.log("init data in callback")
          this.datas = datas;
          console.log("init data in callback finnal",this.options,this.datas)
        });
    },

    emitData(){
      let datasVal = [];

      let datas = this.datas;
      for (let i = 0; i < datas.length; i++) {
        let dataAry = datas[i];
        for (let j = 0; j < dataAry.length; j++) {
          const id = dataAry[j];

          if (datasVal.indexOf(id) == -1) {
            datasVal.push(id);
          }
        }
      }
      this.$emit("onValueChanged", datasVal);
    },

    onDataChanged(){
      console.log("onDataChanged",this.datas)
      
      this.emitData();
    }

  },
  
  mounted() {
    this.init();
  }
}
</script>




<style scoped>
.title {
  font-size: 13px;
  color: #303133;
  width: 80px;
  display: inline-block;
  margin-right: 10px;
}
</style>